import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { PipesModule } from '@core/pipes/pipes.module';
import { LatinValidatorDirective } from '@core/directives/validate/validate-latin.directive';

@NgModule({
	declarations: [LatinValidatorDirective],
	imports: [CommonModule, MatDialogModule, PipesModule],
	exports: [LatinValidatorDirective],
})
export class CoreModule {}
